export default __webpack_public_path__ + "static/media/box1_bak3.da006cfa.png";